// extracted by mini-css-extract-plugin
export default {"optionList":"SO9No","burnInLogo":"dT0U5"};